var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConversationIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 112,
    viewBox: "0 0 122 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3991 0H18.9841C8.49439 0 0 8.54918 0 19.1066V76.7705C0 78.5492 2.16636 79.4098 3.36355 78.1475L20.7514 60.3607H61.3991C71.8888 60.3607 80.3832 51.8115 80.3832 41.2541V19.0492C80.3832 8.54918 71.8888 0 61.3991 0Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1758 35.3438H24.5142C22.9714 35.3438 21.7207 36.6025 21.7207 38.1552C21.7207 39.708 22.9714 40.9667 24.5142 40.9667H59.1758C60.7186 40.9667 61.9693 39.708 61.9693 38.1552C61.9693 36.6025 60.7186 35.3438 59.1758 35.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1758 21.9766H24.5142C22.9714 21.9766 21.7207 23.2353 21.7207 24.788C21.7207 26.3408 22.9714 27.5995 24.5142 27.5995H59.1758C60.7186 27.5995 61.9693 26.3408 61.9693 24.788C61.9693 23.2353 60.7186 21.9766 59.1758 21.9766Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_213_7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6013 33.2793H103.016C113.506 33.2793 122 41.8285 122 52.3859V93.6973V110.05C122 111.828 119.834 112.689 118.637 111.427L101.249 93.64H60.6013C50.1116 93.64 41.6172 85.0908 41.6172 74.5908V52.3859C41.6172 41.8285 50.1116 33.2793 60.6013 33.2793Z",
    fill: "#AEA9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0935 67.9935C82.0935 62.2461 87.7944 63.6829 87.7944 57.9355C87.7944 50.3078 76.3926 50.3079 76.3926 57.9356",
    stroke: "white",
    strokeWidth: 4.59016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0938 75.1649V73.7305",
    stroke: "white",
    strokeWidth: 4.59016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_7314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.3832,
    height: 78.7213,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_213_7314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.3832,
    height: 78.7213,
    fill: "white",
    transform: "translate(41.6172 33.2793)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIllustration);
export default __webpack_public_path__ + "static/media/conversation-illustration.fd92e5eadf94ebb1d83257a4e9d149a1.svg";
export { ForwardRef as ReactComponent };